import React, { useContext, useEffect, useState } from "react";

import { Context } from "../../store/student";
import Selector from "../../atoms/Career/Selector";

import Map from "./Map";
import styles from "./CareerMap.module.scss";

const CareerMap = () => {
  const { contextState } = useContext(Context);
  const [selectedTermNo, setSelectedTermNo] = useState(0);

  const latestSheetTermNo =
    contextState.career_feedback_sheets[0]?.term_no ?? 0;

  useEffect(() => {
    setSelectedTermNo(latestSheetTermNo);
  }, [latestSheetTermNo]);

  const feedbackSheetsForSelectedTermNo =
    contextState.career_feedback_sheets.filter(
      sheet => sheet.term_no === selectedTermNo,
    );

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <p className={styles.title}>キャリア開拓MAP</p>
        <div className={styles.selector}>
          <Selector
            latestTermNo={latestSheetTermNo}
            selectedTermNo={selectedTermNo}
            onChange={setSelectedTermNo}
          />
        </div>
      </div>
      <div className={styles.container}>
        <Map feedbackSheets={feedbackSheetsForSelectedTermNo} />
      </div>
    </div>
  );
};

export default CareerMap;
